import { useId } from 'react'

type Props = {
  className?: string
  disabled?: boolean
}

export const Lock = ({ className, disabled = false }: Props) => {
  const strokeId = useId()
  const fillId = useId()

  return (
    <svg viewBox="0 0 20 28" fill="none" opacity={disabled ? '0.3' : '1'} className={className}>
      <path
        d="M16.28 11.68L16.28 7.14C16.28 3.75 13.53 1 10.14 1L9.60 1C6.21 1 3.46 3.75 3.46 7.14L3.46 11.68"
        stroke={`url(#${strokeId})`}
        strokeWidth="1.64"
      />
      <path
        d="M0.26 11.68H19.48V21.57C19.48 24.95 16.74 27.70 13.35 27.70H6.40C3.01 27.70 0.26 24.95 0.26 21.57V11.68Z"
        fill="#D9D9D9"
      />
      <path
        d="M0.26 11.68H19.48V21.57C19.48 24.95 16.74 27.70 13.35 27.70H6.40C3.01 27.70 0.26 24.95 0.26 21.57V11.68Z"
        fill={`url(#${fillId})`}
      />
      <circle cx="9.87" cy="17.02" r="2.14" fill="black" />
      <rect
        x="8.80"
        y="17.02"
        width="2.14"
        height="5.34"
        fill="black"
      />
      <defs>
        <linearGradient
          id={strokeId}
          x1="4.95"
          y1="4.99"
          x2="17.32"
          y2="7.23"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.36" stopColor="#E7E7E7" />
          <stop offset="1" stopColor="#4F4F4F" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={fillId}
          x1="20.28"
          y1="10.30"
          x2="20.28"
          y2="29.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  )
}
